import { RequestVersionedConnectApi } from "@helpers";

const getCountiesList = () => {
  return RequestVersionedConnectApi.get(`/counties`);
};

const getContactsList = (stateCode, countyName) => {
  return RequestVersionedConnectApi.get(
    `/contacts?stateCode=${stateCode}&countyName=${countyName}`
  );
};

const getContinuingEducationList = (stateCode, countyName) => {
  return RequestVersionedConnectApi.get(
    `/continuingEducation?stateCode=${stateCode}&countyName=${countyName}`
  );
};

const getDocumentsList = (stateCode, countyName) => {
  return RequestVersionedConnectApi.get(
    `/documents?stateCode=${stateCode}&countyName=${countyName}`
  );
};

const getProtocolsList = (stateCode, countyName) => {
  return RequestVersionedConnectApi.get(
    `/protocols?stateCode=${stateCode}&countyName=${countyName}`
  );
};

const getPDFBase64String = (type, id) => {
  return RequestVersionedConnectApi.get(`/${type}?type=${type}&id=${id}`);
};

const getSelfServiceList = (stateCode, countyName) => {
  return RequestVersionedConnectApi.get(
    `/selfService?stateCode=${stateCode}&countyName=${countyName}`
  );
};

const getFormsList = (stateCode, countyName) => {
  return RequestVersionedConnectApi.get(
    `/forms?stateCode=${stateCode}&countyName=${countyName}`
  );
};

const getFormByKey = (formKey) => {
  return RequestVersionedConnectApi.get(`/forms?formKey=${formKey}`);
};

const submitForm = (payload) => {
  return RequestVersionedConnectApi.post(`/forms`, payload);
};

const submitPDFForm = (formKey, payload) => {
  return RequestVersionedConnectApi.post(`/forms?formKey=${formKey}`, payload);
};

const getWebAppVersion = (platform) => {
  return new Promise((resolve, reject) => {
    RequestVersionedConnectApi
      .get('/appUpdate?p1=' + encodeURIComponent(platform))
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
};

export default {
  getCountiesList,
  getContactsList,
  getContinuingEducationList,
  getDocumentsList,
  getProtocolsList,
  getPDFBase64String,
  getSelfServiceList,
  getFormsList,
  getFormByKey,
  submitForm,
  submitPDFForm,
  getWebAppVersion,
};
